import { ChartTemplateTableItemT } from '../../types';
import { RQAPICallWithData } from 'store/APIClient';
import { useQuery } from '@tanstack/react-query';

export const useGetChartTemplatesTable = () =>
    useQuery({
        queryKey: ['chart-templates-table-items'],

        queryFn: async () => {
            const response = await RQAPICallWithData<ChartTemplateTableItemT[]>(
                {
                    endpoint: `support/chart_templates`,
                    method: 'GET',
                },
            );
            return response.content.data;
        },
    });
